import { type ClintplayConfig, DEFAULT_CONFIG } from './types';

export type ResolvedConfig = ClintplayConfig & typeof DEFAULT_CONFIG;

// The API's per-session rate limit on /v1/events is 500/min. A user-set
// `flushIntervalMs` below 1000ms would let the interval-driven path
// alone push past that ceiling and start dropping batches. Clamp here
// so anything lower silently rounds up — the SDK's threshold-driven
// flush (capped at 1/s by MIN_FLUSH_INTERVAL_MS in transport.ts) still
// handles bursty traffic.
const MIN_FLUSH_INTERVAL_MS = 1000;

export function resolveConfig(config: ClintplayConfig): ResolvedConfig {
  if (!config.projectId) {
    throw new Error('[Clintplay] projectId is required');
  }
  if (!config.projectId.startsWith('gp_')) {
    throw new Error('[Clintplay] projectId must start with "gp_"');
  }

  const resolved = { ...DEFAULT_CONFIG, ...config };
  if (resolved.flushIntervalMs < MIN_FLUSH_INTERVAL_MS) {
    resolved.flushIntervalMs = MIN_FLUSH_INTERVAL_MS;
  }
  return resolved;
}
